<template>
    <div>
        <el-input
            class="input-with-s"
            v-model="form.value"
            :name="form.name"
            clearable
            :disabled="form.attr && form.attr.disabled ? true : false"
            :size="form.attr && form.attr.size ? form.attr.size : ''">
            <template #prepend>
                <el-color-picker
                    v-model="form.value"
                    :size="form.attr && form.attr.size ? form.attr.size : ''"
                    :disabled="form.attr && form.attr.disabled ? true : false"
                    :show-alpha="form.attr && form.attr.show_alpha ? true : false"
                    :color-format="form.attr && form.attr.format ? form.attr.format : ''"
                    :name="form.name" />
            </template>
        </el-input>

    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, inject, watch } from 'vue'
    export default defineComponent({
        props: {
            formobj: {
                type: [Array, Object],
                default: () => {}
            }
        },
        setup(props, context) {
            const form = ref(props.formobj)
            return {
                form
            }
        }
    })
</script>

<style>
    .input-with-s .el-input-group__prepend {
        background-color: var(--el-fill-color-blank);
        padding: 0;
    }
    .input-with-s .el-color-picker__trigger{
        border: none;
    }
</style>
